<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_CATEGORY_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết danh mục thiết bị</h1>
      <div style="float: right">
        <button
          v-if="detail.status == 'ACTIVE'"
          @click="LocknUnlock()"
          class="f12 font-medium btn btn-danger mr-2"
        >
          Khoá
        </button>
        <button v-else @click="LocknUnlock()" class="f12 font-medium btn btn-primary mr-2">
          Mở khoá
        </button>
        <button
          v-if="detail.status == 'ACTIVE'"
          @click="$router.push({ path: `/cat-device/edit/${id}` })"
          class="f12 font-medium btn btn-primary mr-2"
        >
          Sửa
        </button>
        <button
          @click="$router.push({ path: `/cat-device` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3 row">
          <div class="form-detail col-sm-6">
            <h1>Thông tin nhóm danh mục thiết bị</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại thiết bị<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.type | transformData(typeDevice) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên đầy đủ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.name }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên rút gọn<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.nickname }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên viết tắt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.abbreviation }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Giá bán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.price | transformMoney }} VNĐ</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Đơn vị<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.unit | transformData(unitDevice) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Quản lý theo serial<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.kind | transformData(Config.checkSerial) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <b-badge
                  class="font-size-12"
                  pill
                  :variant="detail.status == 'ACTIVE' ? 'primary' : 'danger'"
                  size="sm"
                >
                  {{ detail.status | transformData(statusCatDevice) }}
                </b-badge>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.warrantyPeriod">
              <label for="" class="col-sm-4 col-form-label"
                >Thời hạn sử dụng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.warrantyPeriod }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Dịch vụ sử dụng <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.services.join() }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Người tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.userCreator.name }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.dateModified != 0">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian cập nhật<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.dateModified | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.userModifier">
              <label for="" class="col-sm-4 col-form-label"
                >Người cập nhật<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.userModifier.name }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.description != null">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.description }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail col-sm-6">
            <h1>Ảnh</h1>
            <div class="form-group row img-list mr-0 ml-0">
              <ul v-viewer>
                <li v-for="(itemImg, index) in detail.images" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                  </a>
                </li>
                <li v-if="detail.images && detail.images.length == 0">
                  <div class="add-img">
                    <span class="font-size-12">Không có ảnh</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        loading: false,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        id: this.$route.params.id,
        detail: {},
        typeDevice: Config.typeDevice,
        statusCatDevice: Config.statusCatDevice,
        unitDevice: Config.unitDevice,
        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        Config,
      }
    },
    components: {},
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async LocknUnlock() {
        try {
          this.loading = true
          const data = await DeviceService.changeStateCat({
            id: this.id,
            status: this.detail.status === 'ACTIVE' ? 'LOCKED' : 'ACTIVE',
          })
          if (data.success) {
            this.loading = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thao tác thành công'
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          const data = await DeviceService.detailCatDevice({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style></style>
